<template>
  <div class="users-view">
    <!--  <Component /> -->
  users


  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'UsersView',
  components: {
//    'GroupsView': () => import('@/views/holon/GroupsView'),

  },
}
</script>
<style>
.users-view {
  text-align: left;
}
</style>
